import { render } from "./LiabilityTypeList.vue?vue&type=template&id=01964de0&scoped=true"
import script from "./LiabilityTypeList.vue?vue&type=script&lang=js"
export * from "./LiabilityTypeList.vue?vue&type=script&lang=js"

import "./LiabilityTypeList.vue?vue&type=style&index=0&id=01964de0&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01964de0"]])

export default __exports__